export default {
    design: {
        node: {
            /*
             * Narrower and shorter than it was. The card held a title and three
             * lines of text in 300x220 and spent the rest on nothing, which at
             * any useful zoom meant fewer nodes on screen for no more
             * information. The content sets the size now.
             */
            height: 172,
            width: 260,
            /* a quick reply, drawn as one: wide enough for two or three words */
            button: {
                width: 84,
                height: 32
            },
            /* the inlet an edge lands in - a circle, so the diameter is both */
            port: {
                height: 12,
                width: 12
            },
            /* the inside margin everything on the card lines up to */
            padding: 12,
            /*
             * A node that hands the chat to an operator. Much smaller, because
             * it holds a name and a line of text and nothing else - no buttons
             * under it, nothing to add. Reading a tree, these are the ends of
             * the branches, and they should look like ends.
             */
            transfer: {
                width: 210,
                height: 52
            },
            buttonsGap: 8,
            nodeAndButtonContainerGap: 12,
            nodeAndNodePortGap: 8,
            defaultEdgeStartVerticalOffset: 30
        },
        nodesDefaultHorizontalGap: 100,
        levelsDefaultVerticalGap: 120,
        edgeOffsetFromNodes: 20, //should be less than nodesDefaultHorizontalGap and levelsDefaultVerticalGap
        container: {
            defaultTopPadding: 50,
            defaultLeftPadding: 50
        },
        edgeCurveRadius: 10 // should be less than defaultEdgeStartVerticalOffset
    },
    graph: {
        cellSize: 25 // should be less than minimum gaps between nodes
    }
}


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/config/GraphViewConfig.js